<template>
  <div class="col" v-if="firstLoading">
    <skeleton-loading>
      <row>
        <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
      </row>
      <row>
        <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
      </row>
    </skeleton-loading>
  </div>
  <div class="tile" v-else>
    <h3 class="tile-title is-line is-fixed-btn">{{ $t('companyInfo') }}
      <div class="tile-title__btn">
        <i class="icon24-edit-circle-primary h-cursor-pointer" :disabled="loading" @click="edit" v-if="!showForm"></i>
      </div>
    </h3>
    <div class="tile-body text-primary text-center" v-if="loading">
      <b-spinner></b-spinner>
    </div>
    <div class="tile-body" v-else>
      <div class="form-horizontal is-label-right" v-if="!showForm">
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('companyName') }}</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.companyName }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('email') }}</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.email }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{$t('phone')}}</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.phone ? formModel.phone : $t('unknown') }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">Domain</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.domain ? formModel.domain : $t('unknown') }}</span>
          </div>
        </div>
      </div>
      <form class="form-horizontal is-label-right" v-else @submit.prevent="save">
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('companyName') }}</label>
          <div class="col-md-6">
            <form-input type="text" :model="formModel" attribute="companyName" :errors="formErrors"></form-input>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('email') }}</label>
          <div class="col-md-6">
            <form-input type="email" :model="formModel" attribute="email" :errors="formErrors"></form-input>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('phone') }}</label>
          <div class="col-md-6">
            <form-input type="text" :model="formModel" attribute="phone" :errors="formErrors"></form-input>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">Domain</label>
          <div class="col-md-6">
            <form-input type="text" :model="formModel" attribute="domain" :errors="formErrors" disabled="true"></form-input>
          </div>
        </div>
        <hr>
        <div class="form-group row">
          <div class="col-md-6 offset-md-3">
            <button class="btn btn-primary mr-2" type="submit" :disabled="saveLoading">
              <b-spinner v-if="saveLoading" small></b-spinner>
              <span v-else>{{ $t('save') }}</span>
            </button>
            <button class="btn btn-secondary" @click="cancel">{{ $t('cancel') }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      formModel: {},
      loading: false,
      saveLoading: false,
      firstLoading: true,
      showForm: false,
      formErrors: {},
    };
  },
  methods: {
    load() {
      let loadingTimeout = setTimeout(() => {
        this.loading = true;
      }, 250);
      this.$service.get('/profile/client').then(response => {
        this.formModel = response.data;
        this.firstLoading = false;
      }).finally(() => {
        this.loading = false;
        clearTimeout(loadingTimeout);
      });
    },
    edit() {
      this.load();
      this.showForm = true;
    },
    save() {
      this.saveLoading = true;
      this.$service({url: '/profile/client', method: 'put', data: this.formModel}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        }
        this.load();
        this.showForm = false;
      }).catch(error => {
        if (error.response.data.msg) {
          this.$swal({
            text: error.response.data.msg,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        this.saveLoading = false;
      });
    },
    cancel() {
      this.load();
      this.showForm = false;
    }
  },
  mounted() {
    this.firstLoading = true;
    this.load();
  }
}
</script>